import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IReturnType } from '../interfaces';
import { ReturnTypeMapper } from '../mappers';

export type IGetReturnTypesRepoResponse = IRepoResponse<200, IReturnType[]> | IRepoResponse<400 | 500, string>;

export type IGetReturnTypesRepo = IRepo<[any], IGetReturnTypesRepoResponse>;

export const GetReturnTypesRepoType = Symbol.for('GetReturnTypesRepo');

@bind(GetReturnTypesRepoType)
export class GetReturnTypesRepo implements IGetReturnTypesRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/return_reasons', query) });

      if (result.status === 200) {
        const data: IReturnType[] = result.data.data.map((returnType) => ReturnTypeMapper.toDomain(returnType));

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
